// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__e8zCw","heading__upperCase":"Heading_heading__upperCase__1lklN","heading__caption":"Heading_heading__caption__QMFFo"};